/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown> }} Components_Regionalpricingbadge_Closetosuggested4Inputs */

const id_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Penawaran ini mendekati itu, dan jauh di bawah harga tipikal ${i?.region}.`)
};

const ms_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tawaran ini hampir dengan itu, dan jauh di bawah harga tipikal ${i?.region}.`)
};

const da_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette tilbud er tæt på det, og langt under typisk ${i?.region} prissætning.`)
};

const de_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Angebot liegt nah daran und weit unter der typischen ${i?.region}-Preisgestaltung.`)
};

const en_us2_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal is close to that, and well below typical ${i?.region} pricing.`)
};

const es_es2_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta está cerca de eso, y muy por debajo de los precios típicos de ${i?.region}.`)
};

const es_mx2_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta está cerca de eso, y muy por debajo de los precios típicos de ${i?.region}.`)
};

const fil_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ang deal na ito ay malapit riyan, at mas mababa sa tipikal na presyo sa ${i?.region}.`)
};

const fr_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette offre est proche de ce montant, et bien en dessous des prix habituels en ${i?.region}.`)
};

const it_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questa offerta è vicina a quello, e ben al di sotto dei prezzi tipici di ${i?.region}.`)
};

const hu_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ez az ajánlat közel van ehhez, és jócskán a tipikus ${i?.region} árazás alatt van.`)
};

const nl_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deze deal zit dicht bij dat, en ver onder de typische ${i?.region}-prijzen.`)
};

const no_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette tilbudet er nært det, og godt under typisk ${i?.region}-prising.`)
};

const pl_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta oferta jest blisko sugerowanej i znacznie poniżej typowych cen w ${i?.region}.`)
};

const pt_br2_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal is close to that, and well below typical ${i?.region} pricing.`)
};

const pt_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta está próxima do sugerido e bem abaixo do preço típico de ${i?.region}.`)
};

const ro_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Această ofertă este aproape de cea sugerată și mult sub prețul tipic pentru ${i?.region}.`)
};

const fi_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tämä tarjous on lähellä ehdotettua ja selvästi alle tyypillisen ${i?.region} hinnoittelun.`)
};

const sv_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Detta erbjudande ligger nära det rekommenderade och långt under typisk ${i?.region}-prissättning.`)
};

const vi_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi này gần với mức đó và thấp hơn nhiều so với giá điển hình của ${i?.region}.`)
};

const tr_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu fırsat buna yakın ve tipik ${i?.region} fiyatlandırmasının oldukça altında.`)
};

const cs_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tato nabídka se blíží této úrovni a je výrazně pod typickou cenou ${i?.region}.`)
};

const bg_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тази оферта е близо до това и доста под типичното ценообразуване за ${i?.region}.`)
};

const ru_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это предложение близко к этому и значительно ниже типичных цен для ${i?.region}.`)
};

const uk_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ця пропозиція близька до рекомендованої і значно нижча за типову ціну в ${i?.region}.`)
};

const ar_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هذا العرض قريب من ذلك، وأقل بكثير من أسعار ${i?.region} النموذجية.`)
};

const hi_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह डील उसके करीब है, और सामान्य ${i?.region} मूल्य निर्धारण से काफी नीचे है।`)
};

const th_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอนี้ใกล้เคียงกับนั้น และต่ำกว่าราคาทั่วไปของ ${i?.region} มาก`)
};

const ja_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この取引はそれに近く、一般的な ${i?.region} の価格を大幅に下回っています。`)
};

const zh_cn2_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal is close to that, and well below typical ${i?.region} pricing.`)
};

const zh_hant1_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal is close to that, and well below typical ${i?.region} pricing.`)
};

const ko_components_regionalpricingbadge_closetosuggested4 = /** @type {(inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal is close to that, and well below typical ${i?.region} pricing.`)
};

/**
* | output |
* | --- |
* | "This deal is close to that, and well below typical {region} pricing." |
*
* @param {Components_Regionalpricingbadge_Closetosuggested4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricingbadge_closetosuggested4 = /** @type {((inputs: Components_Regionalpricingbadge_Closetosuggested4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricingbadge_Closetosuggested4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "ms") return ms_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "da") return da_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "de") return de_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "fil") return fil_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "fr") return fr_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "it") return it_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "hu") return hu_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "nl") return nl_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "no") return no_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "pl") return pl_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "pt") return pt_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "ro") return ro_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "fi") return fi_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "sv") return sv_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "vi") return vi_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "tr") return tr_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "cs") return cs_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "bg") return bg_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "ru") return ru_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "uk") return uk_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "ar") return ar_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "hi") return hi_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "th") return th_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "ja") return ja_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricingbadge_closetosuggested4(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricingbadge_closetosuggested4(inputs)
	return ko_components_regionalpricingbadge_closetosuggested4(inputs)
});
export { components_regionalpricingbadge_closetosuggested4 as "components.regionalPricingBadge.closeToSuggested" }